export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-array/src/descending.js
// module id = s7oJ
// module chunks = 0